module.exports = __webpack_public_path__ + "img/tableau-simple.c31a1c6d.svg";